import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { ConfigModule, ProcessModule, StateConfig, StateTransferType } from '@spartacus/core';
import { BETON_FEATURE } from './beton-state';
import { reducerProvider, reducerToken } from './reducers';

function betonStoreConfigFactory(): StateConfig {
  return {
    state: {
      ssrTransfer: {
        keys: {
          [BETON_FEATURE]: StateTransferType.TRANSFER_STATE,
        },
      },
    },
  };
}

@NgModule({
  imports: [
    ProcessModule.forRoot(),
    StoreModule.forFeature(BETON_FEATURE, reducerToken),
    ConfigModule.withConfigFactory(betonStoreConfigFactory),
  ],
  providers: [reducerProvider],
})
export class BetonStoreModule {}
